// Require

const { id, log, abs, floor } = require("../std/index")

const { Slice } = require("./master")


//
// "Which Casing" Slice
//

module.exports = class WhichSlice extends Slice {
  constructor($host, config) {
    super($host, config);

    this.stagger = 0.1;

    this.dom.sausages = $('.sausage-icon', $host);
    this.state.num = this.dom.sausages.length;
    this.tween = this.prepareTween();
  }

  prepareTween(d = this.stagger) {
    const tl = new TimelineLite({ paused: true });
    for (let i = 0; i < this.dom.sausages.length; i++) {
      const sausage = this.dom.sausages[i];
      const x = i - this.state.num / 2;
      tl.fromTo(sausage, 0.7, { x: x * 1000 }, { x: 0, ease: Power3.easeOut }, d * abs(x + 0.5));
    }
    return tl;
  }

  onProgress(p) {
    this.tween.seek(p);
  }
};
